import { Address, encodeFunctionData, WalletClient } from 'viem';

import stakingTokenAbi from 'modules/api/abi/LiquidStakingToken';
import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { asAddress } from 'modules/api/utils/asAddress';
import { getChain } from 'modules/api/utils/getChain';

export async function claimUnstake(
  walletClient: WalletClient,
  poolAddress: Address = LIQUID_STAKING_TOKEN_ADDRESS,
): Promise<Address> {
  const encodedData = encodeFunctionData({
    abi: stakingTokenAbi,
    functionName: 'claimUnstake',
  });

  const txHash = await walletClient.sendTransaction({
    to: poolAddress,
    data: encodedData,
    chain: getChain(),
    account: asAddress(walletClient.account?.address || ''),
  });

  return txHash;
}
